import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=5c15504e&"
import script from "./RegisterResult.vue?vue&type=script&lang=js&"
export * from "./RegisterResult.vue?vue&type=script&lang=js&"
import style0 from "./RegisterResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports